// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"MentionEditor_editorContainer__I_39L","mentionEntity":"MentionEditor_mentionEntity__eWCRi","mentionEntityEditable":"MentionEditor_mentionEntityEditable__GsedR"};